import { render, staticRenderFns } from "./fourthCard.vue?vue&type=template&id=2d1b1384&scoped=true&"
import script from "./fourthCard.vue?vue&type=script&lang=js&"
export * from "./fourthCard.vue?vue&type=script&lang=js&"
import style0 from "./fourthCard.vue?vue&type=style&index=0&id=2d1b1384&prod&scoped=true&lang=css&"
import style1 from "./fourthCard.vue?vue&type=style&index=1&id=2d1b1384&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1b1384",
  null
  
)

export default component.exports